import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, finalize } from "rxjs";
import { AppConfig } from "src/app/app.config";

export class BaseService {
  baseUrl = AppConfig.settings?.apiUrls.giganceApi;

  constructor(private baseHttpClient: HttpClient) { }

  public get<Type>(url: string, params: HttpParams | undefined= undefined): Observable<Type>  {
    this.setBaseUrl();
    return this.baseHttpClient
      .get<Type>(
        `${this.baseUrl}/${url}`,
        { params: params }
      );
  }

  public getText(url: string): Observable<string>  {
    this.setBaseUrl();
    return this.baseHttpClient.get(`${this.baseUrl}/${url}`, {responseType: 'text'});
  }

  public getFile(url: string): Observable<Blob>  {
    this.setBaseUrl();
    return this.baseHttpClient
      .get(
        `${this.baseUrl}/${url}`,
        {
          headers: {
            "Accept": "application/pdf"
          },
          responseType: "blob"
        }
      );
  }

  public getExcelFile(url: string, filters: any): Observable<Blob>  {
    this.setBaseUrl();
    return this.baseHttpClient
      .post(
        `${this.baseUrl}/${url}`, filters,
        {
          headers: {
            "Accept": "application/pdf"
          },
          responseType: "blob"
        }
      );
  }

  public post<T>(url: string, body: any | null, headers?: HttpHeaders | undefined): Observable<T> {
    this.setBaseUrl();

    if (headers) {
      return this.baseHttpClient
        .post<T>(
          `${this.baseUrl}/${url}`,
          body,
          {headers: headers}
        );
    }

    return this.baseHttpClient
    .post<T>(
        `${this.baseUrl}/${url}`,
        body
      );
  }

  public postWithProgress<T>(url: string, body: any | null, finalizeMethod: () => void): Observable<HttpEvent<T>> {
    this.setBaseUrl();

    return this.baseHttpClient
    .post<T>(
        `${this.baseUrl}/${url}`,
        body,
        {
          reportProgress: true,
          observe: 'events'
        }
      )
      .pipe(
        finalize(() => finalizeMethod())
      );
  }

  public put<T>(url: string, body: any | null): Observable<T> {
    this.setBaseUrl();
    return this.baseHttpClient
      .put<T>(
        `${this.baseUrl}/${url}`,
        body
      );
  }

  public patch(url: string, body: any | null) {
    this.setBaseUrl();
    return this.baseHttpClient.patch(
      `${this.baseUrl}/${url}`, body);
  }

  public patchWithParam(url: string, body: any | null, params: HttpParams | undefined= undefined) {
    this.setBaseUrl();
    return this.baseHttpClient.patch(
      `${this.baseUrl}/${url}`, body, { params: params });
  }

  public deleteMethod(url: string) {
    this.setBaseUrl();
    return this.baseHttpClient.delete(
      `${this.baseUrl}/${url}`, {});
  }

  private setBaseUrl() {
    if (!this.baseUrl) {
      this.baseUrl = AppConfig.settings?.apiUrls.giganceApi;
    }
  }
}
